import { Base } from '../base-component';

import './carousel-article-related-media-files-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from 'services/media-query.service';

export class CarouselArticleRelatedMediaFilesItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/carousel-article-related-media-files-item/carousel-article-related-media-files-item.component.ts